import React, { createContext, useCallback, useContext, useState } from 'react';

const ToastContext = createContext(null);

let nextId = 0;

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type = 'info', duration = 3000) => {
        const id = ++nextId;
        setToasts(prev => {
            // Cap at 4 visible toasts — remove oldest if needed
            const trimmed = prev.length >= 4 ? prev.slice(1) : prev;
            return [...trimmed, { id, message, type, duration }];
        });
        if (duration > 0) {
            setTimeout(() => removeToast(id), duration);
        }
        return id;
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
};